import React from 'react'
import styled from 'styled-components'
import loadable from '@loadable/component'

import { Header } from '@ui/business-components/Header'
import { HEADER_HEIGHT } from '@app/ui/theme/constants'

const Footer = loadable(() => import('@app/ui/business-components/Footer/Footer'))

export interface LayoutWrapperProps {
  children: React.ReactNode
  headerTransparent?: boolean
  headerProgressBar?: boolean
  pusher?: boolean
  className?: string
}

const LayoutPusher = styled.div`
  margin-top: ${HEADER_HEIGHT}rem;
`

export const LayoutWrapper = ({
  pusher = true,
  headerTransparent = false,
  headerProgressBar = false,
  children,
  className
}: LayoutWrapperProps) => {
  return (
    <>
      <Header transparent={headerTransparent} progressBar={headerProgressBar} />
      {pusher && <LayoutPusher />}
      <main className={className}>{children}</main>
      <Footer />
    </>
  )
}
